import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router'; 
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommaStringToArrayPipe } from '../../comma-string-to-array.pipe';
import { AdminheaderComponent } from './adminheader/adminheader.component';
import { AdminfooterComponent } from './adminfooter/adminfooter.component';
import { AdminloaderComponent } from './adminloader/adminloader.component';

@NgModule({
  declarations: [
    AdminheaderComponent, 
    AdminfooterComponent,
    AdminloaderComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ], 
  exports: [
    AdminheaderComponent, 
    AdminfooterComponent,
    AdminloaderComponent
  ]
})
export class SharedAdminModule { }
